const routes = [{
  path: '/deviceaccess', // 设备接入主页面
  name: 'deviceaccess',
  component: () => import('./pages/Home'),
  meta: {
    requireAuth: false
  },
  children: [{
      path: 'index', // 设备接入主页面
      name: 'devindex',
      component: () => import('./pages/index'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        modules:'deviceaccess'
      }
    },
    {
      path: 'fireEventConfig', // 事件配置
      name: 'fireEventConfig',
      component: () => import('./pages/fireEventConfigNew.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: 'gasConfig', // 可燃气体配置
      name: 'gasConfig',
      component: () => import('./pages/gasConfig.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: 'eventconfignew', // 事件配置
      name: 'eventconfignew',
      component: () => import('./pages/eventConfigNew.vue'),
      meta: {
        requireAuth: false,
        routerAlive: true
      }
    },

    // VCN路由
    {
      path: 'addvcnsystem', // 新增VCN设备系统页面
      name: 'addvcnsystem',
      component: () => import('./components/VCN/AddVcnSystem.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: 'vcndevicelist', // VCN设备列表
      name: 'vcndevicelist',
      component: () => import('./components/VCN/VcnDeviceList.vue'),
      meta: {
        requireAuth: false,
        module:'deviceaccess'
      }
    },
    {
      path: 'vcnsystemlist', // VCN系统列表
      name: 'vcnsystemlist',
      component: () => import('./components/VCN/VcnSystemList.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: 'systemdetail', // VCN系统详情
      name: 'systemdetail',
      component: () => import('./components/VCN/SystemDetail.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      // 设备管理-边缘池管理
      path: 'NvrDeviceMg',
      name: 'NvrDeviceMg',
      component: () => import('./components/VCN/NvrDeviceMg'),
      meta: {
        requireAuth: false
      }
    },
    {
      // 设备管理-消防设备接入
      path: 'fireDeviceMg',
      name: 'fireDeviceMg',
      component: () => import('./components/VCN/fireDeviceMg'),
      meta: {
        requireAuth: false,
        module:'deviceaccess'
      }
    },
    {
      // 一键求救接入
      path: 'touchHelp',
      name: 'touchHelp',
      component: () => import('./components/VCN/touchHelp'),
      meta: {
        requireAuth: false,
        module:'deviceaccess'
      }
    },
    {
      // 告警抑制
      path: 'alarmInhibition',
      name: 'alarmInhibition',
      component: () => import('./pages/alarmInhibition'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        activePath: '/deviceaccess/eventconfignew'
      }
    },
    {
      // 消防告警抑制
      path: 'fireAlarmInhibition',
      name: 'fireAlarmInhibition',
      component: () => import('./pages/fireAlarmInhibition'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        activePath: '/deviceaccess/fireEventConfig'
      }
    },
    {
      // 消防车
      path: 'fireTruckMg',
      name: 'fireTruckMg',
      component: () => import('./components/VCN/fireTruckMg'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module:'deviceaccess'
      },

    },
    {
      // 电气火灾
      path: 'electricFireMg',
      name: 'electricFireMg',
      component: () => import('./components/VCN/electricFireMg'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module:'deviceaccess'
      }
    },
    {
      // 道闸
      path: 'gateWay',
      name: 'gateWay',
      component: () => import('./components/VCN/gateWay'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module:'deviceaccess'
      }
    },
    {
      // IOT
      path: 'IOT',
      name: 'IOT',
      component: () => import('./components/VCN/IOT'),
      meta: {
        requireAuth: false,
        routerAlive: true,
        module:'deviceaccess'
      }
    },
  ]
}]

export default routes